import {useEffect} from 'react'
import {useRoleFormStore, useRoleStore} from '../states/roles.state'
import {KTCard, KTSVG} from '../../../../../_metronic/helpers'
import {UsersListLoading} from '../../user-management/users-list/components/loading/UsersListLoading'
import ReactPaginate from 'react-paginate'
import {FormAction} from '../../../../helpers/form-action-interfaces'
import RoleModalComponent from '../components/role-modal.component'
import {dateTimeISOFormatter} from '../../../../helpers/datetime-formatter'
import {RoleItem} from '../interfaces/roles-result.interface'

const RoleListComponent = () => {
  const {getRoles, roleItems, roleLoading, roleModel, onDelete} = useRoleStore()
  const {setField, field, generateForms, submitDone, formLoading, reset} = useRoleFormStore()

  useEffect(() => {
    getRoles({
      page: 0,
      size: 10,
    })
  }, [])

  useEffect(() => {
    if (submitDone === true && formLoading === false) {
      getRoles({page: 0, size: 10})
      reset()
    }
  }, [submitDone, formLoading])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected
    getRoles({
      page: selectedPage,
      size: 10,
    })
  }

  const openEditModal = (item: RoleItem) => {
    setField(item)
    generateForms({
      title: 'Role',
      subtitle: `Update Role ${item.name}`,
      action: FormAction.UPDATE,
      data: item,
      id: item.id,
    })
  }

  return (
    <>
      {/* <div className='py-5'>
        <div className='rounded border p-5' style={{backgroundColor: 'white'}}></div>
      </div> */}
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Roles</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Role List</span>
          </h3>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-primary'
              onClick={(e) => {
                e.preventDefault()
                setField(null)
                generateForms({
                  title: 'Create New Role',
                  subtitle: 'Create New Role',
                  action: FormAction.CREATE,
                })
              }}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Create New Role
            </button>
          </div>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {roleLoading && <UsersListLoading />}
            <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
              <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                  <th>Role Name</th>
                  <th>Created At</th>
                  <th className='text-end min-w-100px'>Action</th>
                </tr>
              </thead>
              <tbody className='text-gray-600 fw-semibold'>
                {roleItems?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{dateTimeISOFormatter(item.created_at)}</td>
                      <td className='text-end min-w-100px'>
                        <div className='d-flex justify-content-end'>
                          <button
                            className='btn btn-warning btn-sm me-2' // Warning color for Edit button
                            onClick={() => openEditModal(item)}
                          >
                            Edit
                          </button>
                          <button
                            className='btn btn-danger btn-sm' // Danger color for Delete button
                            onClick={() => onDelete(item.id, {page: 0, size: 10})}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <div className='card-footer'>
            <ReactPaginate
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageCount={roleModel?.data?.total_pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              onPageChange={handlePageClick}
              containerClassName={'pagination pagination-sm m-0 float-right'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </KTCard>
      {field !== undefined && <RoleModalComponent />}
    </>
  )
}

const RoleListWrapper = () => {
  return (
    <>
      <RoleListComponent />
    </>
  )
}

export default RoleListWrapper
